enum Mode {
  activation = 'activation',
  recovery = 'recovery',
}

export default Mode;
